import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const RecordManualPaymentMutation = graphql.persisted(
  "RecordManualPayment",
  graphql(`
    mutation RecordManualPayment($input: RecordManualPaymentInput!) {
      recordManualPayment(input: $input) {
        success
        userErrors { message path }
      }
    }
  `)
);

export { RecordManualPaymentMutation };

export function useRecordManualPayment() {
  return useMutation(RecordManualPaymentMutation);
}
